<section *ngIf="!topMenuTemplateService.getTemplate(); else template" class="grid grid-nogutter align-items-center m-0">
    <div class="col-6">
        <p-button (click)="showMenu()" class="btn-menu" icon="pi pi-bars" severity="secondary"></p-button>
    </div>

    <div class="col-6 flex justify-content-end">
        <div class="flex justify-content-between align-items-center config-top">
            <div class="config-top-menu">
                <button class="config-top-button" (click)="openExternalUrl('https://splitpaytutorial.com.br/tutoriais')" [pTooltip]="'Central de ajuda'" tooltipPosition="bottom">
                    <i class="pi pi-question-circle font-bold"></i>
                </button>
            </div>
            <!-- nome e unidade -->
            <div class="flex flex-column align-items-start ml-3">
                <span class="top-name">{{name}}</span>
                <span class="top-unit">{{SelectedUnitName}}</span>
            </div>

            <!-- menu suspenso -->

            <p-overlayPanel #op styleClass="menu-config-top">
                <ng-template pTemplate="content">
                    <div class="overlay-panel ">
                        <!-- <img src="assets/avatar/Avatar.png" alt=""> -->
                        <div class="w-full flex flex-column align-items-center mt-3 mb-2">
                            <span class="top-name text-base">{{name}}</span>
                            <!--
                            <p-dropdown styleClass="modal-dropdown-units" [options]="unitsByUser" [(ngModel)]="SelectedUnit" (onChange)="unitChange($event)" optionLabel="unitName" optionValue="id" placeholder="Selecione uma unidade"  [emptyMessage]="'Nenhuma unidade encontrada'"></p-dropdown>
                                  
                            <span class="top-unit">{{SelectedUnit.unitName}}</span> -->
                        </div>
                         <button class="ajuda" (click)="openExternalUrl('https://splitpaytutorial.com.br/tutoriais')">
                            <i class="pi pi-question-circle text-xl"></i>
                            <span>
                                Central de ajuda
                            </span>
                        </button>

                        <!-- sair -->
                        <button class="sair" (click)="logout()">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_866_3367)">
                                    <path
                                        d="M10.9272 10.0003V10.0096M1.66797 18.3337H18.3346M3.51982 18.3337V3.51884C3.51982 3.0277 3.71493 2.55668 4.06222 2.20939C4.4095 1.8621 4.88053 1.66699 5.37167 1.66699H12.3161M14.6309 11.3892V18.3337M11.8532 5.3707H18.3346M18.3346 5.3707L15.5569 2.59292M18.3346 5.3707L15.5569 8.14847"
                                        stroke="#FF8321" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_866_3367">
                                        <rect width="20" height="20" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>


                            <span>
                                Sair
                            </span>

                        </button>
                    </div>
                </ng-template>
            </p-overlayPanel>
            <button (click)="op.toggle($event)" class="menu-suspenso ml-3">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17 10L12 15L7 10" stroke="#FF8321" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </button>
        </div>
    </div>
</section>
<ng-template #template>
    <section class="grid grid-nogutter align-items-center m-0">
        <ng-container *ngTemplateOutlet="topMenuTemplateService.getTemplate()"></ng-container>
    </section>
</ng-template>

<app-support-chat></app-support-chat>